import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { XIcon } from '@untitledui-icons/react/line'
import { useUIStore } from '@/stores/uiStore'
import { Sidebar } from './Sidebar'
import { cn } from '@/lib/utils'

export function MobileDrawer() {
  const { t } = useTranslation()
  const mobileMenuOpen = useUIStore((state) => state.mobileMenuOpen)
  const setMobileMenuOpen = useUIStore((state) => state.setMobileMenuOpen)

  // Lock body scroll when drawer is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }

    return () => {
      document.body.style.overflow = ''
    }
  }, [mobileMenuOpen])

  // Close on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && mobileMenuOpen) {
        setMobileMenuOpen(false)
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [mobileMenuOpen, setMobileMenuOpen])

  return (
    <>
      {/* Backdrop */}
      <div
        className={cn(
          'fixed inset-0 z-40 bg-gray-900/50 transition-opacity lg:hidden',
          mobileMenuOpen
            ? 'opacity-100'
            : 'pointer-events-none opacity-0'
        )}
        onClick={() => setMobileMenuOpen(false)}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div
        className={cn(
          'fixed inset-y-0 left-0 z-50 flex w-[280px] flex-col bg-white shadow-xl transition-transform duration-300 lg:hidden',
          'dark:bg-gray-900',
          mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        {/* Close button */}
        <button
          type="button"
          onClick={() => setMobileMenuOpen(false)}
          className="absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-800"
          aria-label={t('components.mobile_drawer.close_menu')}
        >
          <XIcon className="h-5 w-5" />
        </button>

        {/* Sidebar content */}
        <Sidebar mobile />
      </div>
    </>
  )
}

export default MobileDrawer
